import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InfoIcon from '@material-ui/icons/Info';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconButton, ListItem, Tooltip } from '@material-ui/core';
import { useRoute } from 'src/app/infra/routes';
import { postAssinaturas } from 'src/app/services/votacao';
import { BtnLoading, Msgbox, Optional } from 'src/app/shared/utils';
import { Token } from 'src/app/types/accounts';
import { useWrapper } from 'src/utils/axios';
import { Form, Title, Wrapper } from '../login';
import { Close } from '@material-ui/icons';

const Centered = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
  font-weight: bold;
`;

const ListUnid = styled.div`
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  overflow: auto;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  h5,
  .MuiFormControl-root {
    width: 100%;
    margin-top: 0px;
  }
`;

interface Props {
  open: boolean;
  handleClose: (done: boolean) => void;
  codigoVotacao: Number | undefined;
  data: Token | undefined;
  identidadeVisual: object;
}

export default ({
  open,
  handleClose,
  codigoVotacao,
  data,
  identidadeVisual
}: Props) => {
  const {
    params: { condominio }
  } = useRoute();
  const sendAssinatura = useWrapper();

  const [nome, setNome] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [unidade, setUnidade] = useState(['']);
  const [outrasUnidades, SetOutrasUnidades] = useState(['']);
  const [unidadeDesc, setUnidadeDesc] = useState('');
  const [outrasUnidadeDesc, setOutrasUnidadeDesc] = useState('');
  const [block, setBlock] = useState(true);
  const [unidadeTipo, setUnidadeTipo] = useState(false);

  useEffect(() => {
    if (open) {
      ValidateUnid();
      if (!nome && !cpfCnpj) {
        setNome(String(data?.nome));
        setCpfCnpj(String(data?.cpfCnpj));
      }
    } else {
      setNome('');
      setCpfCnpj('');
      setUnidade(['']);
      SetOutrasUnidades(['']);
      setOutrasUnidadeDesc('');
      setUnidadeDesc('');
      setUnidadeTipo(false);
      setBlock(true);
    }
  }, [open, nome, cpfCnpj, data]);

  const ValidateUnid = () => {
    setUnidade(Array(String(data?.unidadeLogin?.unidade)));
    setUnidadeDesc(' (' + String(data?.unidadeLogin?.descricaoSituacao) + ')');

    if (data?.outrasUnidadesCpfCnpj?.length) {
      const outrasUnidades: string[] = [];
      data?.outrasUnidadesCpfCnpj?.map((item) => {
        if (item.situacao === 1) {
          outrasUnidades.push(item.unidade);
          SetOutrasUnidades(outrasUnidades);
          setOutrasUnidadeDesc('');
          setOutrasUnidadeDesc(' (' + String(item.descricaoSituacao) + ')');
          setUnidadeTipo(true);
        }
        if (item.situacao === 2) {
          outrasUnidades.push(item.unidade);
          setUnidade(
            outrasUnidades.concat(String(data.unidadeLogin?.unidade)).sort()
          );
          setUnidadeDesc(' (' + String(item.descricaoSituacao) + ')');
        }
      });
    }
  };

  const sendAssinaturas = () => {
    sendAssinatura.exec(
      postAssinaturas({
        votacao: Number(codigoVotacao),
        condominio: Number(condominio),
        unidades: unidade,
        nomeAssinatura: nome,
        cpfAssinatura: cpfCnpj
      }),
      () => handleClose(true)
    );
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <Row>
        <Title
          variant="h5"
          color="primary"
          style={{ color: identidadeVisual['fontColor'] }}
        >
          Assinar Lista de Presença
        </Title>
        <IconButton onClick={() => handleClose(false)}>
          <Close />
        </IconButton>
      </Row>
      <DialogContent>
        <Wrapper>
          <Centered>
            Preencha os dados e confira as unidades que serão representadas pelo
            seu voto. Em seguida clique no botão para acessar a assembleia
            virtual.
          </Centered>
          <Centered style={{ paddingTop: '6px' }}>
            ATENÇÃO: Após assinar a lista de presença, não será possivel eleger
            novo representante para as unidades válidas a baixo.
          </Centered>
          <Form style={{ marginTop: '0rem' }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="nome">Nome</InputLabel>
              <OutlinedInput
                id="nome"
                label="Nome"
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </FormControl>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="cpfCnpj">Cpf/Cnpj</InputLabel>
              <OutlinedInput
                id="cpfCnpj"
                label="Cpf/Cnpj"
                type="text"
                value={cpfCnpj}
                onChange={(e) => setCpfCnpj(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <Centered style={{ paddingBottom: '6px' }}>
                Seu voto representara as seguintes unidades:
              </Centered>
              <ListUnid
                style={{
                  height: Number(unidade?.length) > 1 ? '14vh' : '100%'
                }}
              >
                {unidade?.map((unid) => (
                  <ListItem key={unid} style={{ height: '40%' }}>
                    <ListItemText primary={unid.concat(unidadeDesc)} />
                  </ListItem>
                ))}
              </ListUnid>
            </FormControl>
            <Optional valid={unidadeTipo}>
              <FormControl>
                <Centered>
                  <p style={{ textAlign: 'center' }}>
                    Unidades com procuração que não terão voto representado
                    através deste acesso
                  </p>
                  <Tooltip title="Unidades com procuração reprovada ou não liberada até o momento.">
                    <IconButton>
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </Centered>
                <ListUnid
                  style={{
                    height: Number(outrasUnidades?.length) > 1 ? '14vh' : '100%'
                  }}
                >
                  {outrasUnidades?.map((unid) => (
                    <ListItem key={unid} style={{ height: '40%' }}>
                      <ListItemText primary={unid.concat(outrasUnidadeDesc)} />
                    </ListItem>
                  ))}
                </ListUnid>
              </FormControl>
            </Optional>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  style={{
                    color: identidadeVisual['headerColor'] || '#083F8B'
                  }}
                  checked={!block}
                  onChange={() => setBlock(!block)}
                />
              }
              label="Estou ciente sobre as opções marcadas."
            />
            <BtnLoading
              disabled={!nome || !cpfCnpj || block}
              customColor
              backgroundColor={identidadeVisual['headerColor'] || '#083F8B'}
              loading={sendAssinatura.loading}
              fullWidth
              onClick={sendAssinaturas}
            >
              Assinar e Acessar
            </BtnLoading>
          </Form>
        </Wrapper>
      </DialogContent>
      <Msgbox
        error={sendAssinatura.error}
        onClose={() => sendAssinatura.reset()}
      />
    </Dialog>
  );
};
